<template>
  <div id="home">
    <div class="banner">
      <video
        ref="watchVideo"
        preload="auto"
        playsinline="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        name="media"
        autoplay="autoplay"
        loop muted
        :poster="videoPoster"
        src="https://website.obs.icheer.cn/icheer-web/images/banner.mp4"
      ></video>
    </div>
    <div class="main">
      <div class="solution">
        <h3 class="title">技术解决方案</h3>
        <div class="content">
          <div class="item" v-for="item in solutionList" :key=item.title :style="{ backgroundImage: 'url(' + item.imgsrc + ')' }">
            <div class="text"  @click="$router.push('/solution?model='+item.module)">
              <span class="title">{{ item.title }}</span>
              <span class="description">{{ item.englishTitle }}</span>
              <div class="hr"><hr/></div>
              <span class="summary">{{ item.sumary }}</span>
            </div>
            <div class="bg"/>
          </div>
        </div>
      </div>
      <div class="application">
        <h3 class="title">应用场景</h3>
        <div class="content">
          <div class="item" v-for="item in applicationList" :key="item" :style="{ backgroundImage: 'url(' + item.imgsrc + ')' }">
            <div class="text">
              <span class="title" :style="{color: item.fontColor}">{{ item.title }}</span>
              <span class="description" :style="{color: item.fontColor}">{{ item.englishTitle }}</span>
            </div>
            <span class="text-hover">{{item.hoverTitle}}</span>
            <div class="bg"/>
          </div>
        </div>
      </div>
      <div class="reason" >
        <h3 class="title">为什么选择我们</h3>
        <div class="content" >
          <WhyChooseUs />
          <BrandLogoBarnerFooter  style="width: 90%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import WhyChooseUs from '@/components/WhyChooseUs.vue'
import BrandLogoBarFooter from '@/components/BrandLogoBarnerFooter.vue'

export default {
  name: 'Home',
  components: { BrandLogoBarnerFooter: BrandLogoBarFooter, WhyChooseUs },
  data () {
    return {
      videoPoster: null,
      solutionList: [{
        module: 'bluetooth',
        title: '蓝牙应用',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/jjfa1.jpg',
        englishTitle: 'Bluetooth Application',
        sumary: '美好生活・理想家园'
      },
      {
        module: 'video',
        title: '无线视频',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/jjfa2.jpg',
        englishTitle: 'Wireless Video Application',
        sumary: '看得见・更放心'
      },
      {
        module: 'ultrasound',
        title: '超声波应用',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/jjfa3.jpg?x-image-process=image/resize,w_1920,limit_0',
        englishTitle: 'Ultrasonic Application',
        sumary: '轻松安全・高效洁净'
      },
      {
        module: 'voice',
        title: '语音控制',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/jjfa4.png',
        englishTitle: 'Intelligent Voice',
        sumary: '解放双手・注智赋能'
      }],
      applicationList: [{
        title: '智能穿戴',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-intelligent-wear.jpg',
        englishTitle: 'Smart Wear',
        hoverTitle: '让你更好地感知外部与自己',
        fontColor: 'white'
      },
      {
        title: '运动建康',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-sport-health.jpg',
        englishTitle: 'Sports & Health',
        hoverTitle: '清晰的数据，更容易管理自己的健康',
        fontColor: 'white'
      },
      {
        title: '美容个护',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-beauty.png',
        englishTitle: 'Beauty and Personal Care',
        hoverTitle: '随时随地爱自己，就这么简单',
        fontColor: 'black'
      },
      {
        title: '智能家居',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-smart-home.jpg',
        englishTitle: 'Smart Home',
        hoverTitle: '让你的家更丰富多彩',
        fontColor: 'white'
      },
      {
        title: '宠物关爱',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-pet-care.jpg',
        englishTitle: 'Pet Care',
        hoverTitle: '出门在外，它一样可以被关照得好好的',
        fontColor: 'black'
      },
      {
        title: '户外出行',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/index/application-outdoor.jpg',
        englishTitle: 'Outdoor Travel',
        hoverTitle: '有了它，就像在家里一样安心',
        fontColor: 'white'
      }]
    }
  }
}

</script>
<style scoped>
#home {
  width: 100%;
  min-width: 375px;
}

#home .banner{
  width: 100%;
  height: auto;
  min-width: 375px;
  margin: 0 auto;
}

#home .banner video{
  width: 100%;
  height: auto;
  object-fit: contain;
}

.main{
  height: auto;
  min-width: 375px;
  margin: 0 auto
}

.main,.solution{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center
}

.solution{
  margin: 0 auto 0.08vw auto;
  padding: 2.78vw 0 0 0;
  justify-content: center
}

.solution .title{
  width: 100%;
  margin: 0 auto 2.837vw auto;
  font-size: 1.77vw;
  text-align: center
}

.solution .content {
  width: 63.06%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center
}

.solution .content .item {
  width: 100%;
  border-radius: 0.52vw;
  margin: 0 0 1.075vw 0;
  padding: 8.32vw 0 9.48vw 0;
  font-family: HarmonyOS_Sans_SC_Medium;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100%;
  transition: background-size .5s;
  display: flex;
  justify-content: center
}

.solution .content .item:focus,.solution .content .item:hover {
  background-size: 140%
}

.solution .content .item .text{
  margin: 0 auto;
  z-index: 2;
  opacity: 0.9;
  cursor: pointer;
  text-decoration: none;
  display: block;
  text-align: center
}

.solution .content .item:focus .text,.solution .content .item:hover .text {
  z-index: 4;
  color: #fff
}

.solution .content .item .text .title{
  margin: 0 0 -0.04vw 0;
  font-size: 1.58vw;
  font-weight: 700;
  letter-spacing: -0.02vw;
  display: block;
  text-align: center
}

.solution .content .item .text .description {
  margin: 0 0 0.4vw 0;
  font-size: 1.14vw;
  font-weight: 400;
  letter-spacing: 0.0027vw;
  display: block;
  text-align: center
}

.solution .content .item .text .hr{
  width: 100%;
  height: 2.4vw;
  margin: 0 0 -0.8vw 0
}

.solution .content .item .text .hr hr{
  width: 6vw;
  height: 0.17vw;
  border: 0;
  background-color: #ff7826
}

.solution .content .item .text .summary{
  margin: -0.37vw 0 0 0;
  font-size: 1.03vw;
  font-weight: 400;
  letter-spacing: 0.0125vw;
  display: block;
  text-align: center
}

.solution .content .item .bg{
  border-radius: 0.52vw;
  display: none
}

.solution .content .item:focus .bg,.solution .content .item:hover .bg {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 1;
  background-color: #338afb;
  position: absolute;
  left: 0;
  top: 0;
  display: block
}

.application{
  width: 100%;
  margin: 0 auto 0 auto;
  padding: 1.7vw 0 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center
}

.application .title {
  width: 100%;
  margin: 0 0 0.95vw 0;
  font-size: 1.77vw;
  text-align: center
}

.application .content {
  width: 70%;
  padding: 0.365vw 0 0 0.84vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center
}

.application .content .item {
  width: 44.3%;
  margin: 0 0.84vw 0.84vw 0;
  padding: 10.65vw 0 0 0;
  border-radius: 0.52vw;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 110%;
  transition: background-size 0.5s;
  display: flex;
  justify-content: center
}

.application .content .item:focus,.application .content .item:hover {
  background-size: 140%
}

.application .content .item .text{
  z-index: 2;
  cursor: pointer;
  text-decoration: none;
  display: block;
  text-align: center
}

.application .content .item:focus .text,.application .content .item:hover .text {
  display: none
}

.application .content .item .text .title{
  margin: 0.1vw 0 0.18vw 0;
  font-size: 1.57vw;
  color: #fcfefd;
  display: block;
  text-align: center
}

.application .content .item .text .description{
  margin: 0 0 10vw 0;
  font-size: 1.05vw;
  color: #fcfefd;
  display: block;
  text-align: center
}

.application .content .item .text-hover{
  opacity: 0.9;
  display: none
}

.application .content .item:focus .text-hover,.application .content .item:hover .text-hover {
  width: 100%;
  margin: 0 0 0 0;
  font-size: 1.35vw;
  z-index: 4;
  color: #fff;
  display: block;
  text-align: center
}

.application .content .item .bg{
  border-radius: 0.52vw;
  display: none
}

.application .content .item:focus .bg,.application .content .item:hover .bg {
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.5;
  background-color: #0052d9;
  position: absolute;
  left: 0;
  top: 0;
  display: block
}

#home>.main>.reason{
  width: 100%;
  margin: 0 auto 0 auto;
  padding: 1.95vw 0 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center
}

#home>.main>.reason .title{
  width: 100%;
  margin: 0 0 0.95vw 0;
  font-size: 1.77vw;
  text-align: center
}

#home>.main>.reason .content {
  width: 70%;
  padding: 0.365vw 0 0 0.84vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center
}
</style>
